<template>
  <div @click="handleSelectProduct(product)" class="group relative my-2 lg:my-0 rounded-2xl flex flex-col bg-opacity-70 transition ease-in-out duration-100 hover:rounded-2xl hover:bg-gradient-to-tr hover:from-brand-primary-light hover:to-brand-primary-dark hover:p-1 cursor-pointer" :class="{ 'bg-opacity-100': !isSelectedProduct, 'bg-gradient-to-tr from-brand-primary-light to-brand-primary-dark p-1': isSelectedProduct}">
    <div class="transition ease-in-out group-hover:bg-white p-8 rounded-xl border-black border-solid border hover:border-none" :class="[isSelectedProduct? 'bg-white border-none' : 'bg-opacity-70 bg-white']">
      <div class="absolute h-40 right-10 inset-y-12">
        <img class="absolute right-0 opacity-100 group-hover:opacity-0 transition-opacity ease-in-out duration-300 h-20" :src=product.img />
        <img class="absolute right-0 opacity-0 group-hover:opacity-100 transition-opacity ease-in-out duration-300 h-24" :src=product.imghover />
      </div>
      <h3 class="text-lg font-poppins font-normal text-gray-900">{{ product.name.toUpperCase() }}</h3>
      <div class="mt-0 h-24 flex flex-col items-baseline text-gray-900 leading-9 font-poppins-bold">
        <span :class="['tracking-tight', product.displayDiscount || checkDiscount(product) > 0 ? 'text-decoration-line: line-through text-xl text-gray-500 font-bold' : 'text-5xl text-gray-900 font-extrabold']">${{ checkDiscount(product) > 0 ? checkDiscount(product) : product.price }}</span>
        <span v-if="product.displayDiscount || checkDiscount(product) > 0" class="text-5xl font-extrabold tracking-tight font-poppins-bold">${{ checkDiscount(product) ? product.price : product.discountedPrice }}</span>
      </div>

      <HardwareImage :product="product"></HardwareImage>

      <!-- Feature list -->
      <div role="list" class="mt-0 lg:mt-4 mb-2 space-y-6">
        <div class="flex h-16">
          <span class="text-black font-poppins text-sm">{{ product.description }}</span>
        </div>
      </div>
      <div class="max-w-48 flex rounded-full bg-gradient-to-tr from-brand-primary-light to-brand-primary-dark p-0.5 shadow-md">
          <button class=" cursor-pointer flex-1 text-18 group-hover:bg-transparent px-6 py-3 rounded-full font-poppins border-none" :class="[isSelectedProduct? 'bg-transparent' : 'bg-white']">
              {{ isSelectedProduct ? 'Selected' : 'Select Product'}}
          </button>
      </div>
    </div>
  </div>
</template>

<script setup lang='ts'>
import { defineProps, defineEmits } from 'vue';
import HardwareImage from './HardwareImage.vue';

type Product = {
  id: string,
  name: string,
  description: string,
  price: number,
  discountedPrice?: number,
  displayDiscount?: boolean,
  img?: string,
  imghover?: string
}

defineProps<{
  isSelectedProduct: boolean
  product: Product
}>();

const emit = defineEmits<{(event: 'handle-select-product', product: Product): void}>();

const handleSelectProduct = (product: Product) => {
  emit('handle-select-product', product);
};

const checkDiscount = (product: Product): number => {
  if (product.name === 'Nokia WiFi Beacon 1.1 Bundle 2') {
    return 230;
  }
  if (product.name === 'Nokia WiFi Beacon 2') {
    return 129;
  }
  if (product.name === 'Nokia WiFi Beacon 2 Bundle 1') {
    return 249;
  }
  if (product.name === 'Nokia WiFi Beacon 2 Bundle 2') {
    return 379;
  }
  if (product.name === 'Nokia Beacon 3.1') {
    return 149;
  }
  if (product.name === 'Nokia Beacon 3.1 Bundle 1') {
    return 249;
  }
  return 0;
};

</script>
